/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { ReactComponent as PlusRegularIcon } from "assets/images/icons/common/plus-regular-brand.svg";

const AddImageButton = (props) => {
    const setOpen = props?.setOpen;
    
    return (
        <Fragment>
            <div className="testimonial-default-image-selector" onClick={() => setOpen(true)}>
                <div className="testimonial-default-image-selector-icon">
                    <PlusRegularIcon /> 
                </div>
                <div className="testimonial-default-image-selector-label">Select image</div>
            </div>
        </Fragment>
    );
};

export { AddImageButton };
